import { GetRestockDashboardRowsQuery } from "~/gql/queries/restock/restockDashboard.generated";

export const restockDashboardEndpoints = {
	GetRestockDashboardRows: {
		providesTags: ["RestockDashboardRows"] as AddTagTypes,
		transformResponse: (res: GetRestockDashboardRowsQuery) => res
	}
};
